module.exports = __webpack_public_path__ + "static/media/pinterest.5702c9af.svg";